export default __webpack_public_path__ + "static/media/camper-van.41b75dfd.svg";